// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputComponent {
  position: relative;
  margin-top: 32px;
}
.inputComponent .textField {
  position: relative;
  padding: 0 16px;
  height: 50px;
  width: 100% !important;
  font-size: 16px;
  font-family: "Spoqa Han Sans Neo";
  border-radius: 8px;
  border: none;
  opacity: 100 !important;
}
.inputComponent .textField:focus-visible {
  outline: none !important;
}
.inputComponent .inputWrapper {
  position: relative;
  font-weight: 400;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}
.inputComponent .InputLabel {
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #353d47;
  padding-bottom: 4px;
}
.inputComponent .inputButton {
  border: none;
  width: 100px;
  height: 50px;
  color: #49ae9e;
  background-color: #e5f4f2;
  position: relative;
  display: inline-block;
  margin-left: auto;
  border: 1px solid #d6e7e4;
  font-size: 16px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  border-radius: 8px;
  transition-duration: 0.4s;
  padding: 12px, 16px, 12px, 16px;
}
.inputComponent .inputButton:hover {
  background-color: #49ae9e;
  color: white;
}
.inputComponent .searchInputField {
  position: relative;
  display: flex;
  flex: 1 1;
  margin-right: 10px;
  padding: 0 16px;
  height: 50px;
  color: #353d47;
  font-size: 16px;
  font-family: "Inter";
  font-weight: 400;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  background: #ffffff;
  opacity: 100 !important;
}
.inputComponent .selectField {
  position: relative;
  opacity: 100 !important;
  height: 20px;
  width: 98% !important;
  border: none;
  font-size: 16px;
  font-family: "Inter";
  color: #353d47;
  background-color: white;
}
.inputComponent .buttonAndInputContainer {
  display: flex;
  justify-content: space-between;
}

.inputExtender {
  margin-top: 10px;
}

.dropDownComponent {
  position: relative;
  margin-top: 32px;
}
.dropDownComponent .inputWrapper {
  position: relative;
  font-weight: 400;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}
.dropDownComponent .InputLabel {
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #353d47;
  padding-bottom: 4px;
}
.dropDownComponent .selectField {
  position: relative;
  padding-left: 16px;
  height: 50px;
  width: 98% !important;
  color: #353d47;
  font-size: 16px;
  font-family: "Inter";
  border: none;
  border-radius: 8px;
  background-color: white;
  opacity: 100 !important;
}
.dropDownComponent .bottomText {
  margin-top: 11px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #bbbbbb;
}

.radioHeaderGroup {
  position: relative;
  display: inline-block;
  /* Hide the browser's default radio button */
  /* Create a custom radio button */
  /* On mouse-over, add a grey background color */
  /* When the radio button is checked, add a blue background */
  /* Create the indicator (the dot/circle - hidden when not checked) */
  /* Show the indicator (dot/circle) when checked */
  /* Style the indicator (dot/circle) */
}
.radioHeaderGroup .header {
  margin-bottom: 12px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.radioHeaderGroup .radioContainer {
  display: inline-block;
  position: relative;
  padding-left: 35px;
  padding-right: 35px;
  cursor: pointer;
  font-size: 22px;
}
.radioHeaderGroup .itemText {
  position: relative;
  right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.radioHeaderGroup input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.radioHeaderGroup .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 2px solid #E1E1E1;
  border-radius: 50%;
}
.radioHeaderGroup .radioContainer:hover input ~ .checkmark {
  background-color: white !important;
  border: 2px solid #E1E1E1;
}
.radioHeaderGroup .radioContainer input:checked ~ .checkmark {
  border: 2px solid #353d47;
}
.radioHeaderGroup .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.radioHeaderGroup .radioContainer input:checked ~ .checkmark:after {
  display: block;
  background-color: rgb(0, 0, 0);
}
.radioHeaderGroup .radioContainer .checkmark:after {
  top: 3px;
  left: 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #353d47;
}`, "",{"version":3,"sources":["webpack://./src/components/inputBox/inputBox.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;AACJ;AACI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;AACR;AAEI;EACI,wBAAA;AAAR;AAEI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAAR;AAGI;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AADR;AAGI;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;AADR;AAGI;EACI,yBAAA;EACA,YAAA;AADR;AAII;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAFR;AAKI;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;AAHR;AAMI;EACI,aAAA;EACA,8BAAA;AAJR;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,gBAAA;AAJJ;AAKI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAHR;AAKI;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAHR;AAKI;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;AAHR;AAKI;EACI,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHR;;AAMA;EACI,kBAAA;EAEA,qBAAA;EA6BA,4CAAA;EAOA,iCAAA;EAWA,+CAAA;EAMA,4DAAA;EAKA,oEAAA;EAOA,iDAAA;EAMA,qCAAA;AApEJ;AADI;EACI,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGR;AADI;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAGR;AADI;EACI,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGR;AAAK;EACG,kBAAA;EACA,UAAA;EACA,eAAA;AAER;AAEI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAAR;AAII;EACI,kCAAA;EACA,yBAAA;AAFR;AAMI;EACI,yBAAA;AAJR;AAQI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AANR;AAUI;EACI,cAAA;EACA,8BAAA;AARR;AAYI;EACI,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAVR","sourcesContent":[".inputComponent {\n    position: relative;\n    margin-top: 32px;\n\n    .textField {\n        position: relative;\n        padding: 0 16px;\n        height: 50px;\n        width: 100% !important;\n        font-size: 16px;\n        font-family: 'Spoqa Han Sans Neo';\n        border-radius: 8px;\n        border: none;\n        opacity: 100 !important;\n    }\n\n    .textField:focus-visible {\n        outline: none !important;\n    }\n    .inputWrapper {\n        position: relative;\n        font-weight: 400;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n    }\n\n    .InputLabel {\n        position: relative;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #353d47;\n        padding-bottom: 4px;\n    }\n    .inputButton {\n        border: none;\n        width: 100px;\n        height: 50px;\n        color: #49ae9e;\n        background-color: #e5f4f2;\n        position: relative;\n        display: inline-block;\n        margin-left: auto;\n        border: 1px solid #d6e7e4;\n        font-size: 16px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        border-radius: 8px;\n        transition-duration: 0.4s;\n        padding: 12px, 16px, 12px, 16px;\n    }\n    .inputButton:hover {\n        background-color: #49ae9e;\n        color: white;\n    }\n\n    .searchInputField {\n        position: relative;\n        display: flex;\n        flex: 1;\n        margin-right: 10px;\n        padding: 0 16px;\n        height: 50px;\n        color: #353d47;\n        font-size: 16px;\n        font-family: 'Inter';\n        font-weight: 400;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        background: #ffffff;\n        opacity: 100 !important;\n    }\n\n    .selectField {\n        position: relative;\n        opacity: 100 !important;\n        height: 20px;\n        width: 98% !important;\n        border: none;\n        font-size: 16px;\n        font-family: 'Inter';\n        color: #353d47;\n        background-color: white;\n    }\n\n    .buttonAndInputContainer {\n        display: flex;\n        justify-content: space-between;\n    }\n}\n.inputExtender {\n    margin-top: 10px;\n}\n\n.dropDownComponent {\n    position: relative;\n    margin-top: 32px;\n    .inputWrapper {\n        position: relative;\n        font-weight: 400;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n    }\n    .InputLabel {\n        position: relative;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #353d47;\n        padding-bottom: 4px;\n    }\n    .selectField {\n        position: relative;\n        padding-left: 16px;\n        height: 50px;\n        width: 98% !important;\n        color: #353d47;\n        font-size: 16px;\n        font-family: 'Inter';\n        border: none;\n        border-radius: 8px;\n        background-color: white;\n        opacity: 100 !important;\n    }\n    .bottomText {\n        margin-top: 11px;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 15px;\n        color: #bbbbbb;\n    }\n}\n.radioHeaderGroup{ \n    position: relative;\n    // bottom: 25px;\n    display: inline-block;\n\n    .header {\n        margin-bottom: 12px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    } \n    .radioContainer {\n        display: inline-block;\n        position: relative;\n        padding-left: 35px;\n        padding-right: 35px; \n        cursor: pointer;\n        font-size: 22px;\n    }\n    .itemText {\n        position: relative;\n        right: 5px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n    /* Hide the browser's default radio button */\n     input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n    }\n\n    /* Create a custom radio button */\n    .checkmark {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 20px;\n        width: 20px;\n        border: 2px solid #E1E1E1;\n        border-radius: 50%;\n    }\n\n    /* On mouse-over, add a grey background color */\n    .radioContainer:hover input ~ .checkmark {\n        background-color: white !important;\n        border: 2px solid  #E1E1E1;\n    }\n\n    /* When the radio button is checked, add a blue background */\n    .radioContainer input:checked ~ .checkmark { \n        border: 2px solid #353d47;\n    }\n\n    /* Create the indicator (the dot/circle - hidden when not checked) */\n    .checkmark:after {\n        content: '';\n        position: absolute;\n        display: none;\n    }\n\n    /* Show the indicator (dot/circle) when checked */\n    .radioContainer input:checked ~ .checkmark:after {\n        display: block; \n        background-color: rgb(0, 0, 0); \n    }\n\n    /* Style the indicator (dot/circle) */\n    .radioContainer .checkmark:after {\n        top: 3px;\n        left: 3px;\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        background: #353d47;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
